export default __webpack_public_path__ + "static/media/Rectangle_bg.aa39f1ae.svg";